import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-addloandetails',
  templateUrl: './addloandetails.component.html',
  styleUrls: ['./addloandetails.component.css']
})
export class AddloandetailsComponent implements OnInit {


  constructor(private toastr: ToastrService,private appService: AppdataService,
    public loginService:LoginserviceService,private activeModal: NgbActiveModal,private confirmationDialogService: ConfirmationDialogService) { }

//Save Validation
submitted:boolean;
successfully:boolean;

loandetailsform=new FormGroup({
  loandetid:new FormControl(0),           
  effectivedt:new FormControl('',Validators.required),   
  amount: new FormControl('', Validators.required),   
  refno: new FormControl(''),   
  descr:new FormControl(''),   
});


@Input() loandetid:any=0;
@Input() effectivedt:any=new Date();
@Input() amount:any=null;
@Input() refno: any = "";
@Input() descr: any = "";
  
@Input() loanremainingamount: any = null;
@Input() remainingamount: any = null;
  
@Input() instalmentamount: any = null;
  
@Input() loandt: any = null;
  
@Output() emitData = new EventEmitter();


ngOnInit() {

  this.loandetailsform.reset();
  this.fnInitializeFormGroup(); 

}


fnInitializeFormGroup(){
this.loandetailsform.setValue({
  loandetid:this.loandetid,       
  effectivedt:this.effectivedt,   
  amount: this.amount, 
  refno: this.refno,
  descr:this.descr,
})
}


fnSaveBtnClick(){
try{
  this.submitted=true;
  this.successfully=false;
  //Validate
  if (this.loandetailsform.valid) {
      
    var _effectivedt = this.loandetailsform.get('effectivedt').value;
   
    // /this.loandetid && 
    if (this.loandt) {
      if(Date.parse(_effectivedt)<Date.parse(this.loandt)){
        this.loandetailsform.controls['effectivedt'].setErrors({'notfound': true});
        return
      }
    }

    if (this.fnValidateAmount()) {
      this.loandetailsform.controls['amount'].setErrors({'notfound': true});
      return
    }

    //Check
    var data = {
      loandetid: this.loandetid,                      
      effectivedt:this.loandetailsform.get('effectivedt').value,      
      amount: this.loandetailsform.get('amount').value,                         
      descr: this.loandetailsform.get('descr').value,                         
      refno:this.loandetailsform.get('refno').value,                         
    }
    this.emitData.emit(data);  
    this.activeModal.close(true);  

  }

}catch(ex){
this.fnShowErrorMsg(ex);
}
}

fnCalculateRemainingAmount() {
  
  var amount = this.loandetailsform.get('amount').value;
  
  this.remainingamount = this.loanremainingamount - amount
  
}
  
fnValidateAmount() {
  var amount = this.loandetailsform.get('amount').value;

  if (amount > 0) {
    if (this.remainingamount<0) {
      return true;
    }
    else {
      return false;
    }
  }
  else {
    return false;
  }

  
}

public decline() {
this.activeModal.close(false);
}


private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}




}
